import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import DataTable from './datatable';

import ContainerHeader from '../../../components/ContainerHeader/index';
import * as esignaturedetails from '../../../actions/esignaturedetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';

class eSignatureList extends Component {

    constructor(props) {
        super(props)
        this.state = { committee_id: Number(this.props.params.id ? this.props.params.id : this.props.loginUser.data.committee_id) }
    }


    componentDidMount() {
        // console.log('props', this.props)
        this.props.actions.geteSignatureDetailsList();
    }

    render() {
        const { getDataList, teamDetails, match } = this.props;

        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('getDataList', getDataList);
        if ((getDataList && getDataList.Status) || (teamDetails && teamDetails.Status)) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        // console.log('message', message);
        if (getDataList && getDataList.esignaturedetailsList && getDataList.esignaturedetailsList.length > 0) {
            // dataList = getDataList.esignaturedetailsList.map((_data, index) => {
            //     return (<TableCell key={index} data={_data} index={index} />);
            // })
        }
        let _TeamList = null
        // console.log('AddRole TeamList', roleList)
        const committeeList = teamDetails.switchteamdetailsList;
        if (committeeList && committeeList.length > 0) {
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500' }}>
                    {team.name}
                </MenuItem>
            ))
        }

        return (
            <div className="slideInUpTiny ">
                {message}
                <ContainerHeader title="eSignature List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <Card className="mb-0">

                            <CardHeader className="bg-white p-0">
                                <div className="row p-2">
                                    <div className="col-6 pt-2 pl-4"> eSignature List</div>
                                    <div className="col-2 text-right pt-2"> </div>

                                    <div className="col-4">

                                    </div>
                                </div>
                            </CardHeader>
                        </Card>
                        <div className="row">
                            <div className="col-12">
                                {/* <h1 className="bg-primary text-white p-3 mb-0">eSignature List a</h1> */}
                                <DataTable data={getDataList && getDataList.esignaturedetailsList && getDataList.esignaturedetailsList.length > 0 ? getDataList.esignaturedetailsList : null} />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { loginUser, esignatureDetails, teamDetails } = state
    const { match } = ownProps
    return { loginUser, getDataList: esignatureDetails, teamDetails, params: ownProps.match.params, match }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, esignaturedetails, loadswitchercommittees), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(eSignatureList);



// WEBPACK FOOTER //
// ./app/esignaturedetails/esignaturelist/index.js